// A Rólam szekció fotói. Új kép hozzáadásához csak ide kell egy új elem.
// fit: 'cover' (kitölti a keretet) vagy 'contain' (teljes kép látszik, pl. a BB Gym feliratos fotónál).
export const ABOUT_PHOTOS = [
  {
    id: 'gym-2026',
    webp: '/orosz-gabor-gym-960.webp',
    fallback: '/orosz-gabor-gym-960.jpg',
    alt: 'Orosz Gábor okleveles sportedző a miskolci edzőteremben',
    position: 'center 30%',
  },
  {
    id: 'about-v2',
    webp: '/orosz-gabor-about-v2.webp',
    fallback: '/orosz-gabor-about-v2.jpg',
    alt: 'Orosz Gábor – okleveles testépítés-fitnesz sportedző, Miskolc',
    position: 'center 20%',
  },
  {
    id: 'bbgym',
    webp: '/orosz-gabor-bbgym-1000.webp',
    fallback: '/orosz-gabor-bbgym-1000.jpg',
    alt: 'Orosz Gábor személyi edző a miskolci BB Gymben',
    fit: 'contain',
  },
];

// A kisebb (800px) változatok az aloldalakhoz.
export const ABOUT_PHOTOS_SMALL = [
  {
    id: 'gym-2026-800',
    webp: '/orosz-gabor-gym-800.webp',
    fallback: '/orosz-gabor-gym-800.webp',
    alt: 'Orosz Gábor okleveles sportedző a miskolci edzőteremben',
    position: 'center 30%',
  },
  {
    id: 'about-800',
    webp: '/orosz-gabor-about-800.webp',
    fallback: '/orosz-gabor-about-800.webp',
    alt: 'Orosz Gábor személyi edző',
    position: 'center 20%',
  },
  {
    id: 'bbgym-800',
    webp: '/orosz-gabor-bbgym-800.webp',
    fallback: '/orosz-gabor-bbgym-800.webp',
    alt: 'Orosz Gábor személyi edző a miskolci BB Gymben',
    fit: 'contain',
  },
];
